import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e2dd3c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mypage py-3" }
const _hoisted_2 = { class: "section px-3 pt-4 mt-2" }
const _hoisted_3 = { class: "bg-white border border-outline-color px-3 mt-1 round-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "電話番号変更", -1))
const _hoisted_5 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "パスワード変更", -1))
const _hoisted_7 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "源泉徴収票の発行", -1))
const _hoisted_9 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "メール・プッシュ通知受信設定", -1))
const _hoisted_11 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "業務カテゴリ設定", -1))
const _hoisted_13 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "事業所ミュート設定", -1))
const _hoisted_15 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "緊急連絡先", -1))
const _hoisted_17 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "その他", -1))
const _hoisted_19 = { class: "d-flex justify-content-end align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _ctx.onClickBack
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      アカウント情報\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_RouterLink, {
            to: { name: 'EditPhoneNumber' },
            class: "d-flex justify-content-between align-items-center py-3"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_FeatherIcon, {
                  icon: "chevron-right",
                  size: "1x",
                  class: "text-gray-05 ml-2"
                })
              ])
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(_component_RouterLink, {
            to: { name: 'ResetPassword' },
            class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createTextVNode(),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_FeatherIcon, {
                  icon: "chevron-right",
                  size: "1x",
                  class: "text-gray-05 ml-2"
                })
              ])
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(_component_RouterLink, {
            to: { name: 'Withholding' },
            class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createTextVNode(),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_FeatherIcon, {
                  icon: "chevron-right",
                  size: "1x",
                  class: "text-gray-05 ml-2"
                })
              ])
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(_component_RouterLink, {
            to: { name: 'MypageNotification' },
            class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _createTextVNode(),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_FeatherIcon, {
                  icon: "chevron-right",
                  size: "1x",
                  class: "text-gray-05 ml-2"
                })
              ])
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          (_ctx.isShownSetWorkerService)
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                to: { name: 'SetWorkerService' },
                class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3"
              }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _createTextVNode(),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_FeatherIcon, {
                      icon: "chevron-right",
                      size: "1x",
                      class: "text-gray-05 ml-2"
                    })
                  ])
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createTextVNode(),
          _createVNode(_component_RouterLink, {
            to: { name: 'MuteList' },
            class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          }, {
            default: _withCtx(() => [
              _hoisted_14,
              _createTextVNode(),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_FeatherIcon, {
                  icon: "chevron-right",
                  size: "1x",
                  class: "text-gray-05 ml-2"
                })
              ])
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(_component_RouterLink, {
            to: { name: 'EditEmergencyContactOfRelationship' },
            class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          }, {
            default: _withCtx(() => [
              _hoisted_16,
              _createTextVNode(),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_FeatherIcon, {
                  icon: "chevron-right",
                  size: "1x",
                  class: "text-gray-05 ml-2"
                })
              ])
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(_component_RouterLink, {
            to: { name: 'OtherAccountInfo' },
            class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          }, {
            default: _withCtx(() => [
              _hoisted_18,
              _createTextVNode(),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_FeatherIcon, {
                  icon: "chevron-right",
                  size: "1x",
                  class: "text-gray-05 ml-2"
                })
              ])
            ], undefined, true),
            _: 1
          })
        ])
      ]),
      _createTextVNode(),
      _createVNode(_component_AppFooter),
      _createTextVNode(),
      _createVNode(_component_BlockBack)
    ])
  ]))
}